import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { TeamListAnalyticsEffects } from '../app-entities/team-list/team-list-analytics.effects';
import { FollowersEffects } from '../followers/followers.effects';
import { followersReducer } from '../followers/followers.reducer';

import { GainsightPXEffects } from './analytics/gainsight/_state/gainsight-px.effects';
import { HubspotEffects } from './analytics/hubspot/_state/hubspot.effects';
import { AppGlobalAnalyticsEffects } from './analytics/segment/app-global-analytics.effects';
import { SegmentEffects } from './analytics/segment/segment.effects';
import { anonymousStateReducer } from './anonymous/anonymous-state.reducer';
import { AuthSignupEffects } from './auth/auth-signup.effects';
import { AuthStateReducer } from './auth/auth-state.reducer';
import { ChangeEmailEffects } from './auth/change-email/change-email.effects';
import { ChangePhoneNumberEffects } from './auth/change-phone-number/change-phone-number.effects';
import { BootstrapEffects } from './auth/effects/bootstrap.effects';
import { TokenEffects } from './auth/effects/token.effects';
import { TotpEffects } from './auth/effects/totp-effects';
import { LoginEnableMfaEffects } from './auth/login/login-enable-mfa.effects';
import { LoginMfaEffects } from './auth/login/login-mfa.effects';
import { LoginMicrosoftEffects } from './auth/login/login-microsoft.effects';
import { LoginEffects } from './auth/login/login.effects';
import { LogOutEffects } from './auth/logout/logout.effects';
import { ChangePasswordEffects } from './auth/password/change-password.effects';
import { ForgotPasswordEffects } from './auth/password/forgot-password.effects';
import { UserAccountEffects } from './auth/user-account/user-account.effects';
import { BannerNotificationStateEffects } from './banner-notification/banner-notification.effects';
import { bannerNotificationStateReducer } from './banner-notification/banner-notification.reducer';
import { BillingAnalyticsEffects } from './billing/billing-analytics.effects';
import { BillingStateEffects } from './billing/billing-state.effects';
import { BillingStateReducer } from './billing/billing-state.reducer';
import { CompanyStateEffects } from './company/company-state.effects';
import { companyStateReducer } from './company/company-state.reducer';
import { SubscriptionStateEffects } from './company/subscription/subscription-state.effects';
import { CurrentPersonEffects } from './current-person/current-person.effects';
import { currentPersonStateReducer } from './current-person/current-person.reducer';
import { detailPanelReducer } from './detail-panel/detail-panel.reducer';
import { EntitlementsStateEffects } from './entitlements/entitlements-state.effects';
import { EntitlementsStateReducer } from './entitlements/entitlements-state.reducer';
import { helpfulPermissionsReducer } from './helpful-permissions/helpful-permissions.reducer';
import { IntercomStateEffects } from './intercom/intercom-state.effects';
import { LanguageEffects } from './language/language.effects';
import { languageReducer } from './language/language.reducer';
import { NavigationStateEffects } from './navigation/navigation.effects';
import { navigationStateReducer } from './navigation/navigation.reducer';
import { NotificationStateEffects } from './notifications/notification.effects';
import { OneSignalEffects } from './one-signal/one-signal.effects';
import { RealTimeEffects } from './real-time/real-time.effects';
import { RealTimeReducer } from './real-time/real-time.reducer';
import { SpinnerStateReducer } from './spinner/spinner-state.reducers';
import { ThirdPartyScriptsEffects } from './third-party-scripts/third-party-scripts.effects';
import { ViewportStateEffects } from './viewport/viewport.effects';
import { viewportStateReducer } from './viewport/viewport.reducer';

import {
  AnonymousStateKey,
  AppGlobalState,
  AppGlobalStateKey,
  AuthStateKey,
  BannerNotificationStateKey,
  BillingStateKey,
  CompanyStateKey,
  CurrentPersonStateKey,
  DetailPanelStateKey,
  EntitlementsStateKey,
  FollowersStateKey,
  HelpfulPermissionsKey,
  LanguageStateKey,
  NavigationStateKey,
  RealTimeStateKey,
  SpinnerStateKey,
  ViewportStateKey,
} from '.';

export const appStateReducers: ActionReducerMap<AppGlobalState> = {
  [AuthStateKey]: AuthStateReducer,
  [BannerNotificationStateKey]: bannerNotificationStateReducer,
  [CompanyStateKey]: companyStateReducer,
  [EntitlementsStateKey]: EntitlementsStateReducer,
  [FollowersStateKey]: followersReducer,
  [LanguageStateKey]: languageReducer,
  [RealTimeStateKey]: RealTimeReducer,
  [HelpfulPermissionsKey]: helpfulPermissionsReducer,
  [CurrentPersonStateKey]: currentPersonStateReducer,
  [BillingStateKey]: BillingStateReducer,
  [AnonymousStateKey]: anonymousStateReducer,
  [SpinnerStateKey]: SpinnerStateReducer,
  [ViewportStateKey]: viewportStateReducer,
  [NavigationStateKey]: navigationStateReducer,
  [DetailPanelStateKey]: detailPanelReducer,
};

@NgModule({
  imports: [
    StoreModule.forFeature(AppGlobalStateKey, appStateReducers),
    EffectsModule.forFeature([
      AuthSignupEffects,
      BootstrapEffects,
      TokenEffects,
      LoginEffects,
      LoginEnableMfaEffects,
      LoginMfaEffects,
      LoginMicrosoftEffects,
      UserAccountEffects,
      ChangePasswordEffects,
      ChangeEmailEffects,
      ChangePhoneNumberEffects,
      ForgotPasswordEffects,
      TotpEffects,
      LogOutEffects,
      CompanyStateEffects,
      EntitlementsStateEffects,
      CurrentPersonEffects,
      FollowersEffects,
      IntercomStateEffects,
      LanguageEffects,
      RealTimeEffects,
      NotificationStateEffects,
      SubscriptionStateEffects,
      BannerNotificationStateEffects,
      BillingStateEffects,
      BillingAnalyticsEffects,
      ViewportStateEffects,
      NavigationStateEffects,
      OneSignalEffects,
      ThirdPartyScriptsEffects,
      GainsightPXEffects,
      SegmentEffects,
      HubspotEffects,
      AppGlobalAnalyticsEffects,
      TeamListAnalyticsEffects,
    ]),
  ],
})
export class AppGlobalStateModule {}
